import { AuditorEdit } from "api/entities/bases/auditor";
import AuditorEditFormData from "./form/auditor-edit-form-data";

const create = (formData: AuditorEditFormData, originalLogin: string | undefined): AuditorEdit => {
  let phonePrefix: string | undefined;
  let phone: string | undefined;
  const formPhone = formData.phone.replace(/\s/g, "");

  if (formPhone.startsWith("+")) {
    phonePrefix = formPhone.substring(0, 3);
    phone = formPhone.substring(3);
  } else {
    phonePrefix = "+48";
    phone = formPhone;
  }

  const login = formData.login === originalLogin ? undefined : formData.login.trim();

  return {
    email: formData.email.trim(),
    login: login,
    name: formData.name.trim(),
    surname: formData.surname.trim(),
    password: !!formData.password ? formData.password : undefined,
    phone: phone,
    phone_prefix: phonePrefix,
    address: !!formData.address ? formData.address : undefined,
    company_id: !!formData.companyId ? formData.companyId : undefined,
    types: formData.types,
  };
};

const auditorEditRequestFactory = {
  create,
};

export default auditorEditRequestFactory;
